<template>
  <Card shadow class="x-login-modal" :padding="0">
    <div class="login-modal-wrap">
      <Tabs :value="tabOn" @on-click="changeTab">
        <TabPane label="散客购票" name="person">
          <div class="qrcode" ref="qrCodeUrl" :title="title"></div>
          <Spin size="large" fix v-if="spinShow1"></Spin>
        </TabPane>
        <TabPane label="团体购票" name="company">
          <div class="qrcode" ref="ttqrCodeUrl" :title="title"></div>
          <Spin size="large" fix v-if="spinShow2"></Spin>
        </TabPane>
      </Tabs>
      <!-- <div class="qrcode" ref="qrCodeUrl"></div>
          <div class="qrcode" ref="ttqrCodeUrl"></div>
      <Button @click="_redirect()">关闭</Button>-->
      <div>
        请使用
        <span class="wxlogin">微信</span>扫码登录
      </div>
      <div class="login-bottom">
        <img src="@/assets/weixin_logo.png" alt="" class="weixin-logo">
        <Button type="text" style="box-shadow: none;" @click="toJudge('company')">单位注册</Button>
        <Button type="text" style="box-shadow: none;" @click="toJudge('guide')">导游注册</Button>
      </div>
<!--      <div v-else style="height: 60px;"></div>-->
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
    <!-- 确认注册 -->
    <Modal v-model="registerShow" width="360" @on-cancel="cancel">
      <p slot="header" style="text-align:center">
        <span>注册提示</span>
      </p>
      <div style="text-align:center">
        <p>您的账号尚未注册, 请先选择下方类型进行注册</p>
      </div>
      <div slot="footer" style="text-align: center">
        <Button type="text" style="box-shadow: none;" @click="toRegister('company')">单位注册</Button>
        <Button type="text" style="box-shadow: none;" @click="toRegister('guide')">导游注册</Button>
      </div>
    </Modal>
  </Card>
</template>

<script>
import QRCode from 'qrcodejs2'
import { v4 } from 'uuid'
import Vue from 'vue'
import api from '@/api'
import { httpAction } from '@/api/manage'

export default {
  inject: ['reload'],
  data () {
    return {
      title: null,
      modal: true,
      num: '',
      socket: '',
      loading: true,
      spinShow1: true,
      spinShow2: true,
      tabOn: 'person',
      ws: null,
      heartCheck: {},
      registerShow: false
      // url: {
      //   searchGroup: '/openapi/guide/info'
      // }
    }
  },
  created () {
    const that = this
    this.ws = new WebSocket(process.env.VUE_APP_WEBSOCKET)
    this.heartCheck = {
      timeout: 10000,
      timeoutObj: null,
      serverTimeoutObj: null,
      reset: function () {
        if (this.timeoutObj) clearTimeout(this.timeoutObj)
        if (this.serverTimeoutObj) clearTimeout(this.serverTimeoutObj)
        return this
      },
      start: function () {
        var self = this
        this.timeoutObj = setTimeout(function () {
          // 这里发送一个心跳，后端收到后，返回一个心跳消息，
          // onmessage拿到返回的心跳就说明连接正常
          const obj = {
            heartBeat: 'HeartBeat' + new Date()
          }
          if (that.ws) {
            if (that.ws.readyState===1) {
              that.ws.send(JSON.stringify(obj))
            }
          }
          // console.info('客户端发送心跳：' + new Date())
          self.serverTimeoutObj = setTimeout(function () { // 如果超过一定时间还没重置，说明后端主动断开了
            if (that.ws) that.ws.close() // 如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
          }, self.timeout)
        }, this.timeout)
      }
    }
  },
  mounted () {
    const user = this.$route.query.user
    if (user) {
      this.tabOn = user
    }
    setTimeout(() => {
      this.openWebsocket()
      this.creatQrCode()
      this.creatTtQrCode()
      this.loading = false
    }, 500)
    // setTimeout(() => {
    //   this.$router.replace('/order')
    // }, 5000)
  },
  beforeDestroy () {
    // if (this.tabOn === 'person') {
    //   document.getElementById("qrCodeUrl").innerHTML = "";
    // } else {
    //   document.getElementById("ttqrCodeUrl").innerHTML = "";
    // }
    this.socket.close()
    this.socket = null
    this.ws = null
  },
  methods: {
    toRegister(type) {
      this.$router.push({path: '/register', query: {type: type}})
    },
    toJudge(type) {
      this.$router.push({path: '/judge', query: {type: type}})
    },
    changeTab(name){
      this.tabOn = name
    },
    openWebsocket () {
      if (window.WebSocket) {
        this.num = this._MathTand()
        this.socket = this.ws
        this.websocketonopen()
        this.socket.onopen = this.websocketonopen
        this.socket.onmessage = this.websocketonmessage
        this.socket.onerror = this.websocketonerror
        this.socket.onclose = this.websocketclose
      }
    },
    websocketonopen () {
      var wwaKey = this.num
      this.heartCheck.reset().start()
      if (this.ws.readyState===1) {
        this.ws.send('{"transCode":"wwareq","wwaKey":"' + wwaKey + '"}')
      }
    },
    websocketonerror () {
      // console.log('连接出错')
    },
    websocketonmessage (e) {
      var wwaKey = this.num
      var jsonObj = JSON.parse(e.data)
      console.log(jsonObj)
      const redirect = this.$route.query.redirect
      // 判断是否是微信网页授权的业务
      // eslint-disable-next-line no-prototype-builtins
      if (jsonObj.hasOwnProperty('transCode') && jsonObj.hasOwnProperty('wwaKey')) {
        if (wwaKey === jsonObj.wwaKey) {
          // 微信网页授权业务建立websocket是否成功
          if (jsonObj.transCode === 'wwareq') {
            if (jsonObj.res === '0') {
              // TODO 这里是例子，具体连接成功之后的业务自己实现
              // alert('websocket连接成功!')
            } else {
              // TODO 这里是例子，具体连接失败之后的业务自己实现
              alert('websocket连接失败!')
            }
            // 微信网页授权响应结果
          } else if (jsonObj.transCode === 'wwares') {
            // Vue.ls.set('token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiJvajl2cnZ6MmNMcGNieUJlNEtLTEpDaDJDb2M0IiwidHlwZSI6IjAiLCJpYXQiOjE1OTQyOTQ0NDIsImV4cCI6MTU5NDI5ODA0Mn0.Z3OIJxm54QFev61K4ojJFtzwGNg8hXYeSsejY3FhCKI')
            this.spinShow1 = true
            this.spinShow2 = true
            this.$store.dispatch('setToken', jsonObj.token)
            this.$store.dispatch('setType', jsonObj.type)
            Vue.ls.remove('group')
            if (jsonObj.type === '1') {
              let obj = {
                userType: 'weixin'
              }
              Vue.ls.set('temporary', jsonObj.token)
              httpAction(api.searchGroup, 'post', obj).then(res => {
                // console.log('--------')
                // console.log(res.data)
                let data = res.data
                Vue.ls.set('group', 'group')
                if (data) { // 已注册
                  Vue.ls.set('token', jsonObj.token)
                  Vue.ls.set('refresh_token', jsonObj.refresh_token)
                  Vue.ls.set('type', jsonObj.type)
                  Vue.ls.set('headimgurl', jsonObj.headimgurl)
                  Vue.ls.set('nickname', jsonObj.nickname)
                  Vue.ls.remove('temporary')
                  if (redirect && redirect.indexOf('register') < 0) {
                    this.$router.push(redirect)
                  } else {
                    this.$router.push('/')
                  }
                  this.reload()
                  return
                }

                httpAction(api.groupCheckList, 'post', obj).then(checkRes => {
                  const checkInfo = checkRes.data
                  // console.log('12321123---')
                  console.log(checkRes)
                  if (checkInfo === undefined) {
                    // console.log('12323')
                    this.registerShow = true
                    // console.log(this.registerShow)
                    return
                  } else {
                    this.$router.push({ path: '/register-status', query: { status: checkInfo.checkStatus } })
                  }
                  this.reload()
                })

                // if (data) {
                //   if (data.registerStatus === 'un_register') {
                //     // this.$router.push('/register')
                //     this.registerShow = true
                //     // this.reload()
                //     // this.$Message.warning('您的账号尚未注册, 请先选择下方类型进行注册')
                //   } else if (data.registerStatus === 'register') {
                //     Vue.ls.set('token', jsonObj.token)
                //     Vue.ls.set('type', jsonObj.type)
                //     Vue.ls.set('headimgurl', jsonObj.headimgurl)
                //     Vue.ls.set('nickname', jsonObj.nickname)
                //     Vue.ls.remove('temporary')
                //     if (redirect && redirect.indexOf('register') < 0) {
                //       this.$router.push(redirect)
                //     } else {
                //       this.$router.push('/')
                //     }
                //     this.reload()
                //   } else {
                //     this.$router.push({ path: '/register-status', query: { status: data.registerStatus } })
                //     this.reload()
                //   }
                // } else {
                //   this.$Message.warning('系统错误')
                // }
              })
            } else {
              Vue.ls.set('token', jsonObj.token)
              Vue.ls.set('refresh_token', jsonObj.refresh_token)
              Vue.ls.set('type', jsonObj.type)
              Vue.ls.set('headimgurl', jsonObj.headimgurl)
              Vue.ls.set('nickname', jsonObj.nickname)
              if (redirect) {
                this.$router.push(redirect)
              } else {
                this.$router.push('/')
              }
              this.reload()
            }
            // this.common.isLogin()
            // if (redirect) {
            //   this.$router.push(redirect)
            // } else {
            //   this.$router.push('/')
            // }
            // TODO 这里是例子，具体获取到授权token之后的业务自己实现
            // alert(JSON.stringify(jsonObj))
            // this.modal = false
          }
        }
      } else {
        // alert('其它业务不实现!')
        this.heartCheck.reset().start()
      }
    },
    websocketclose (e) {
      // 关闭
      console.log('服务器关闭')
    },
    cancel(){
      this.reload()
    },
    creatQrCode () {
      // const num = this._MathTand()
      // const url =
      //   'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf16488f084933f91&redirect_uri=http%3a%2f%2fauth.test.sjtickettech.com%2fwechat%2fwebpage%2fauthorization%2fnotify%2f&response_type=code&scope=snsapi_userinfo&state=wxf16488f084933f91,' +
      //   this.num +
      //   ',0#wechat_redirect'
      const url = `https://pc.xiangshantickets.com/login/pc-authorization.html?appid=${process.env.VUE_APP_APPID}&redirect_uri=${encodeURI(process.env.VUE_APP_REDIRECT_URI)}&response_type=code&scope=snsapi_userinfo&state=${process.env.VUE_APP_STATE},${this.num},0#wechat_redirect`
      // eslint-disable-next-line no-unused-vars
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: url,
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
      this.spinShow1 = false
    },
    creatTtQrCode () {
      // const num = this._MathTand()
      // const url =
      //   'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf16488f084933f91&redirect_uri=http%3a%2f%2fauth.test.sjtickettech.com%2fwechat%2fwebpage%2fauthorization%2fnotify%2f&response_type=code&scope=snsapi_userinfo&state=wxf16488f084933f91,' +
      //   this.num +
      //   ',1#wechat_redirect'
      const url = `https://pc.xiangshantickets.com/login/pc-authorization.html?appid=${process.env.VUE_APP_APPID}&redirect_uri=${encodeURI(process.env.VUE_APP_REDIRECT_URI)}&response_type=code&scope=snsapi_userinfo&state=${process.env.VUE_APP_STATE},${this.num},1#wechat_redirect`
      // eslint-disable-next-line no-unused-vars
      var qrcode = new QRCode(this.$refs.ttqrCodeUrl, {
        text: url,
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
      this.spinShow2 = false
    },
    _MathTand () {
      var num = ''
      // for (var i = 0; i < 6; i++) {
      //   num += Math.floor(Math.random() * 10)
      // }
      num = v4()
      return num
    }
  }
}

</script>

<style scoped lang="less">
.x-login-modal {
  display: flex;
  position: absolute;
  left: calc(50% + 120px);
  margin: 10px auto 0;
  height:375px;
  width: 480px;
}
.ivu-modal {
  top: 0;
}
.qrcode {
  margin-top: 10px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}
.wxlogin{
  font-size:16px;
  color:@font-red
}
</style>

<style lang="less">
.x-login-modal{
  div{
    width: 100%;
  }
  button{
    background: unset!important;
  }
  .login-modal-wrap{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    text-align: center;
  }

  .ivu-tabs-tab{
    width: 50%;
    height: 62px;
    line-height: 46px;
    margin: 0;
    font-size: 20px;
    &:hover{
      color: unset;
    }
  }

  .ivu-tabs-ink-bar{
    display: none;
  }

  .ivu-tabs-tab-active{
    background-color: @common;
    color: #fff!important;
  }

  .ivu-card-body{
    width: 100%;
  }
  .login-bottom{
    padding-left: 240px;
    line-height: 60px;
    background: #f7f7f7;
    position: relative;
    .weixin-logo{
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
